import { HttpErrorResponse, HttpInterceptorFn } from "@angular/common/http";
import { inject } from "@angular/core";
import { catchError, throwError } from "rxjs";
import { GlobalStore } from "../store/global.store";
import { DISABLE_LOGGING } from "../pages/auth/services/auth.service";
import { Router } from "@angular/router";
import { AuthStore } from '../pages/auth/store/auth.store';
import { environment } from '../../environments/environment';
import { ACCOUNT_DENIAL_REASONS } from '../pages/auth/model/user.mode';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const globalStore = inject(GlobalStore);
  const router = inject(Router);
  const authStore = inject(AuthStore);
  const isSubscriptionRequest = /subscription|billing|payment/i.test(req.url);

  return next(req).pipe(
    catchError((err: any) => {
      const disableLogging = req.context.get(DISABLE_LOGGING);

      if (err instanceof HttpErrorResponse) {
        if (req.url.startsWith(environment.baseUrl) && err.status === 403
          && Object.hasOwn(ACCOUNT_DENIAL_REASONS, err.error?.code ?? '')) {
          authStore.denyAccountAccess(err.error.code);
          return throwError(() => err);
        }
        if (err.status == 428) {
          router.navigate(["/auth", "select-organization"]);
        }

        if (![401, 428].includes(err.status) && !disableLogging) {
          if (err.status === 403 && isSubscriptionRequest) {
            globalStore.showSnackBar(
              "You do not have permission to manage this subscription. Please contact your account administrator.",
              "error",
            );
          } else {
            globalStore.showErrorSnackBar(err);
          }
        }
      }

      return throwError(() => err);
    })
  );
};
